import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import { createBrowserHistory } from "history";
import {
  connectRouter,
  routerMiddleware,
} from "connected-react-router/immutable";
import { Map as IMap } from "immutable";
import { ravenMiddleware } from "@lifepay/redux-subsystem-handle-error";
import { USE_RAVEN } from "config";
import reducers from "./reducers";
import sagas from "./sagas";

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({
  collapsed: true,
  duration: true,
});

const middlwareList = [sagaMiddleware, routerMiddleware(history), logger];
if (USE_RAVEN) {
  middlwareList.push(ravenMiddleware);
}
const middleware = applyMiddleware(...middlwareList);

const initialState = IMap();
const store = createStore(
  connectRouter(history)(reducers),
  initialState,
  compose(
    middleware,
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined"
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

sagaMiddleware.run(sagas);

export default store;



// WEBPACK FOOTER //
// ./src/model/store.js